import { render, staticRenderFns } from "./form-select.vue?vue&type=template&id=47acc7e6&"
import script from "./form-select.vue?vue&type=script&lang=js&"
export * from "./form-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports